import { Dispatch, SetStateAction, createContext } from "react";
import { InitialEval } from "../../models";

export interface ITissueGradingContext {
    tissueGrading: InitialEval | undefined;
    setTissueGrading: Dispatch<SetStateAction<InitialEval | undefined>>;
    isFetching: boolean;
    setIsFetching: Dispatch<SetStateAction<boolean>>;
    isSaving: boolean;
    setIsSaving: Dispatch<SetStateAction<boolean>>;
    isLocked: boolean;
    lockedByName: string;
    unlock: (tissueId: number | string) => Promise<void>;
    sign: (pin: string) => Promise<InitialEval | undefined>;
    unlockSigned: (pin: string) => Promise<InitialEval | undefined>;
    isLockedByMe: boolean;
    isSigned: boolean;
    isDisabled: boolean;
}

const defaultValue: ITissueGradingContext = {
    tissueGrading: undefined,
    setTissueGrading: () => {},
    isFetching: false,
    setIsFetching: () => {},
    isSaving: false,
    setIsSaving: () => {},
    isLocked: false,
    lockedByName: "",
    unlock: async () => {},
    sign: async () => undefined,
    unlockSigned: async () => undefined,
    isLockedByMe: false,
    isSigned: false,
    isDisabled: false,
};

export const TissueGradingContext = createContext<ITissueGradingContext>(defaultValue);
TissueGradingContext.displayName = "TissueGrading";
